import * as d3 from 'd3';
import { GuidHelper } from '../../..';
import { ItemFormat } from '../interfaces';
import { ElementRender } from './ElementeRenderer';

export class Tooltip extends ElementRender {
    private _selection: d3.Selection<any>;
    private _position: { x: number, y: number } = { x: 0, y: 0 };
    constructor(container: d3.Selection<any>) {
        super(container, 'crosshair-group');
        this.width(120)
            .height(20);
        const id = `crosshairClipPath${GuidHelper.getGuid()}`;
        const w = this.width();
        const h = this.height();
        const crosshairGroup = this.container();
        const crosshairContentGroup = crosshairGroup.append('g')
            .classed('content', true)
            .classed('hidden-group', true);

        crosshairContentGroup
            .append('defs')
            .append('clipPath')
            .attr('id', id)
            .append('rect')
            .classed('crosshair-clippath', true)
            .attr({
                'width': w,
                'height': h
            });

        const crosshairTextGroup = crosshairContentGroup.append('g')
            .classed('crosshair-text-group', true)
            .style({
                'clip-path': `url("#${id}")`
            });
        crosshairTextGroup.append('rect')
            .classed('crosshair-text-group', true)
            .attr({
                'x': 0,
                'y': 0,
                'width': w,
                'height': h
            });
        // crosshairTextGroup.append('text')
        //     .classed('crosshair-text title', true)
        //     .style('stroke', 'none')
        //     .attr('x', 5)
        //     .attr('y', 15);
        crosshairTextGroup.append('text')
            .classed('crosshair-text value', true)
            .style('stroke', 'none')
            .attr('x', 5)
            .attr('y', 15);
        this._selection = container;
    }

    position(): { x: number, y: number };
    position(value: { x: number, y: number }): this;
    position(value?: { x: number, y: number }): this | { x: number, y: number } {
        if (!arguments.length) {
            return this._position;
        }
        this._position = value;
        return this;
    }

    render(d: ItemFormat) {
        const group = this._selection.select('g.crosshair-group');
        group.transition()
            .duration(50)
            .attr('transform', () => {
                const { x, y } = this._position;
                return `translate(${x}, ${y})`;
            });
        group.select('.content')
            .classed('hidden-group', !this.visible());
        if (d) {
            // group.select('text.title')
            //     .style('fill', d.item.color)
            //     .text(`${d.item.label}`);
            group.select('text.value')
                .style('fill', d.item.color)
                .text(`${d.item.formattedValue}`);
        }
    }
}